export enum FreightOrderActionTypes {
  REQUEST_FREIGHT_BOOKING = "REQUEST_FREIGHT_BOOKING",
  SET_FREIGHT_BOOKING_ID = "SET_FREIGHT_BOOKING_ID",
}

export const generateFreightBookingLoaderId = "generateFreightBooking";
